import React, { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import FirstReport from "./FirstReport";
import SecondReport from "./SecondReport";
import ThirdReport from "./ThirdReport";
import { useHistory } from "react-router-dom";
import { CONDITIONALROUTES, STEPS } from "app/components/ConditionalEnums";
import { CostData } from "atoms/CostToCarbonData";

const CurrentReports = ({ staticDataOfMachine, isHotSpotAvailable,
  setCppData,
  cppData,
  setTotalJobs,
  totalJobs,
  setSingleJobTime,
  singleJobTime,
  machineImage,
  setMachineimage,  
  psImage,
  setPsImage,
  setcppSum,
  cppSum,
  setHotSpotArray,
  hotspotArray,
  scenarioTotalJobs,
  scenarioJobsLoading,

 }) => {
  const [step, setStep] = useState("first");
  const [costData, setCostData] = useState()
  const history = useHistory();
  const updatedCostData = useRecoilValue(CostData)
  useEffect(() => {
    if (history.location.pathname === CONDITIONALROUTES.GENERATEDREPORT) {
      setCostData(updatedCostData);
    }
    else {
      setCostData(staticDataOfMachine);
    }
  }, [])
  return (

    <>
      {
        costData !== undefined
        &&
        <>
          <div className="reports-section">
            {step === STEPS.ONE && (
              <FirstReport
                staticDataOfMachine={costData}
                ScenarioState={() => setStep(STEPS.TWO)}
                isWorkingPerJobEditable={true}
                isHotSpotAvailable={isHotSpotAvailable}
                PreviousScenarioState={() => setStep(STEPS.ONE)}
                setCppData={setCppData}
                cppData={cppData}
                setTotalJobs={setTotalJobs}
                totalJobs={totalJobs}
                setSingleJobTime={setSingleJobTime}
                singleJobTime={singleJobTime}
                machineImage={machineImage}
                setMachineimage={setMachineimage}
                psImage={psImage}
                setPsImage={setPsImage}
                setcppSum={setcppSum}
                cppSum={cppSum}
                setHotSpotArray={setHotSpotArray}
                  hotspotArray={hotspotArray}
              />
            )}
            {step === STEPS.TWO && (
              <SecondReport
                isWorkingPerJobEditable={true}
                staticDataOfMachine={costData}
                isHotSpotAvailable={isHotSpotAvailable}
                PreviousScenarioState={() => setStep(STEPS.ONE)}
                ScenarioState={() => setStep(STEPS.THREE)}
              />
            )}
            {step === STEPS.THREE && (
              <ThirdReport
                PreviousScenarioState={() => setStep(STEPS.TWO)}
                staticDataOfMachine={costData}
                scenarioTotalJobs={scenarioTotalJobs}
                scenarioJobsLoading={scenarioJobsLoading}
              />
            )}
          </div>

        </>

      }

    </>
  );
};

export default CurrentReports;
